export const NOTIFICATION_TIMEOUT_IN_MILLISECONDS = 15000

export const MAX_VOICE_CONNECTIONS = 6

export const MAX_VOICE_CONNECTIONS_WITH_BARGE = MAX_VOICE_CONNECTIONS + 1
